import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import Card from "components/molecules/Card/Card";
import Button from "components/atoms/Button/Button";
import { getShipmentTemplates } from "api";
import errorToast from "helpers/errorToast";
import { generateUUID } from "helpers/commonHelpers";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import QuickActionsWidget from "../../../widgets/QuickActionsWidget";
import QuickActionsRow from "./QuickActionsRow";
import "../WidgetBuilder.scss";

function QuickActionsWidgetBuilder({ handleWidgetContentClick, widgetContent }) {
  const defaultButton = {
    id: generateUUID(),
    type: "create_quote_request",
    template: {
      name: "",
      id: null,
    },
  };

  const [isLoading, setIsLoading] = useState(false);
  const [templates, setTemplates] = useState(null);
  const [allQuickActions, setAllQuickActions] = useState(widgetContent ? JSON.parse(widgetContent) : [defaultButton]);

  const loadShipmentTemplates = () => {
    setIsLoading(true);
    getShipmentTemplates()
      .then((res) => {
        setTemplates(res.data);
        setIsLoading(false);
      })
      .catch((err) => errorToast(err));
  };

  useEffect(() => {
    loadShipmentTemplates();
  }, []);

  useEffect(() => {
    handleWidgetContentClick(JSON.stringify(allQuickActions));
  }, [allQuickActions]);

  const addQuickAction = () => {
    setAllQuickActions((prevActions) => [...prevActions, defaultButton]);
    setTimeout(() => {
      const quickActionsContainer = document.getElementById("quick-actions-container");
      quickActionsContainer.scrollTop = quickActionsContainer.scrollHeight;
    }, 250);
  };

  if (isLoading || !templates) return <LoadingSkeleton rows={1} noShadow />;

  return (
    <div className="d-flex flex-column flex-md-row modal-mx-300">
      <div>
        <div className="d-flex">
          <Col className="choose-widget-column">
            <p className="choose-widget-title">
              <FormattedMessage id="dashboard.widgetDialog.widgetType.chooseAction" defaultMessage="Choose action" />
            </p>
          </Col>
          <Col className="choose-widget-column">
            <p className="choose-widget-title">
              <FormattedMessage id="dashboard.widgetDialog.widgetType.chooseTemplate" defaultMessage="Choose template" />
            </p>
          </Col>
        </div>
        <div id="quick-actions-container">
          {allQuickActions.length > 0 &&
            allQuickActions.map((action) => (
              <QuickActionsRow
                templates={templates}
                setAllQuickActions={setAllQuickActions}
                allQuickActions={allQuickActions}
                action={action}
              />
            ))}
        </div>
        <Button variant="primary" onClick={addQuickAction}>
          <FormattedMessage id="dashboard.widgetDialog.widgetType.quickActionsAdd" defaultMessage="Add Quick Action" />
        </Button>
      </div>
      <div>
        <Col className="preview-widget-column mt-3 mt-md-0">
          <p className={`choose-widget-title ${!widgetContent && "text-secondary"}`}>
            <FormattedMessage id="general.preview" defaultMessage="Preview" />
          </p>
          {widgetContent.length > 0 && (
            <div style={{ marginLeft: 5, border: "16px solid #F1F3F4", borderRadius: "24px" }} className="preview-card">
              <Card className="flex-grow-0 p-0">
                <QuickActionsWidget isLayoutLocked isPreview widgetContent={widgetContent} />
              </Card>
            </div>
          )}
        </Col>
      </div>
    </div>
  );
}

QuickActionsWidgetBuilder.propTypes = {
  handleWidgetContentClick: PropTypes.func.isRequired,
  widgetContent: PropTypes.string.isRequired,
};

export default QuickActionsWidgetBuilder;
